import { FC, useContext } from "react";
import ModalClaim from "components/Modals/ModalClaim";
import Modal from "utils/hookedComponents/Modal";
import { GameContext } from "pages/Game";
import { Rewards } from "pages/Game/core/game.types";
import { useGameLoss } from "./core/gameLoss.hook";

const GameLoss: FC = () => {
  const gameContext = useContext(GameContext);
  const { isVisible, showModal, reference } = { ...gameContext };

  useGameLoss({ showModal });

  return isVisible ? (
    <Modal
      reference={reference}
      isVisible={isVisible}
      content={<ModalClaim reward={Rewards.loss} />}
    />
  ) : null;
};

export default GameLoss;
